import { useState, useEffect } from 'react';
import Schedule from './Schedule.js';

const Print = ({ user, bikes, logout, sendEmail }) => {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dez'];

    let [formData, setFormData] = useState([]);
    let [locations, setLocations] = useState([]);
    let [dates, setDates] = useState([]);
    let [loaded, setLoaded] = useState(false);

    function getDateFromSlotStartTime(startTime) {
        const [year, month, dayWithTime] = startTime.split('/');
        const day = parseInt(dayWithTime, 10);

        return {
            day,
            month: parseInt(month, 10) - 1,
            year: parseInt(year, 10)
        };
    }

    function getDateKeyFromDateParts(dateParts) {
        const month = String(dateParts.month + 1).padStart(2, '0');
        const day = String(dateParts.day).padStart(2, '0');

        return dateParts.year + '/' + month + '/' + day;
    }

    function getDateKeyFromSlot(slot) {
        return slot.start_time.slice(0, 10);
    }

    function isTodayOrFuture(dateParts) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const slotDate = new Date(dateParts.year, dateParts.month, dateParts.day);
        return slotDate.getTime() >= today.getTime();
    }

    function handleChangeInput(event) {
        loaded = false;
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        const name = target.name;

        let localData = { ...formData };
        //console.log('Target name: ', name)
        //console.log('Value: ', value)
        if (name === "location") {
            let iValue = parseInt(value);
            localData[name] = iValue;;
            localData.name = locations.filter(x => x.id === iValue)[0].name;
        } else {
            localData[name] = value;
        }

        //console.log(localData);
        setLoaded(false);
        setFormData(localData);
    }



    function loadLocations() {
        // Fetch all locations, then fetch all pickup slots
        // console.log("fetch locations...");
        fetch("/getAllLocations")
            .then(res => {
                let r = res;
                // console.log(r);
                return r.json();
            })
            .then(res => {
                let locations = res;
                // console.log(locations);
                const selectLocationBox = document.getElementById('location');
                selectLocationBox.innerHTML = '';
                let option = document.createElement("option");
                option.text = "-- Choose --";
                option.value = "choose";
                selectLocationBox.add(option);

                locations.forEach(d => {
                    let option = document.createElement("option");
                    option.value = d.id;
                    option.text = d.id + " - " + d.name;
                    selectLocationBox.add(option);
                })
                setLocations(locations);
            })
            .catch(
                e => {
                    //console.log("Error fetching locations:" + e)
                    alert("There was an error connecting to our server to load the locations. Please logout, login and try again. Error: " + e)
                    logout()
                }
            )

    }

    useEffect(() => {
        loadLocations();
    }, []);

    useEffect(() => {

        loaded = false;
        if (locations && user.type!="superAdmin") {
            if (locations.length>0){
            const location = user.location
            let localData = { ...formData };
            localData.location = user.location;
            localData.name = locations.filter(x => x.id === location)[0].name;
            setLoaded(false);
            setFormData(localData);
        }
    }
    }, [locations]);

    useEffect(() => {
        const selectDateBox = document.getElementById('date');
        selectDateBox.innerHTML = '';
        let option = document.createElement("option");
        option.text = "-- Choose --";
        option.value = "choose";
        selectDateBox.add(option);
        if (dates) {
            dates.forEach(d => {
                let option = document.createElement("option");
                option.text = d.day + '/' + months[d.month] + '/' + d.year + ' (' + d.peopleCount + ')';
                option.value = d.day + "/" + d.month + '/' + d.year;
                selectDateBox.add(option);
            })
        }
    }, [formData.location, locations, dates]);

    useEffect(() => {
        loadDates();
    }, [locations, formData.location]);


    function loadDates() {
        // Fetch all pickup slots
        // console.log("fetch pickup slots...");
        Promise.all([
            fetch("/getAllPickupSlots").then(res => {
                let r = res;
                return r.json();
            }),
            fetch("/getAllUsers", {
                method: "POST",
                body: JSON.stringify({}),
                headers: { "Content-Type": "application/json" }
            }).then(res => {
                let r = res;
                return r.json();
            })
        ])
            .then(([slots, users]) => {
                // console.log('Slots:', slots);
                // console.log('Location id:', formData.location)
                let slotsAtLocation = slots.filter(s => s.location_id === formData.location);
                const occupiedSlotIds = new Set(
                    users
                        .filter(u => u.pickup_slot)
                        .map(u => u.pickup_slot)
                );
                const peopleCountByDateKey = slotsAtLocation.reduce((counts, slot) => {
                    const slotDateKey = getDateKeyFromSlot(slot);

                    if (occupiedSlotIds.has(slot.id)) {
                        counts[slotDateKey] = (counts[slotDateKey] || 0) + 1;
                    }

                    return counts;
                }, {});
                //console.log('Slots at Location = ', slotsAtLocation)
                const visibleDateKeys = new Set(
                    slotsAtLocation
                        .filter(slot => {
                            const dateParts = getDateFromSlotStartTime(slot.start_time);
                            const slotDateKey = getDateKeyFromSlot(slot);

                            if (isTodayOrFuture(dateParts)) {
                                return true;
                            }

                            return slotsAtLocation.some(locationSlot => (
                                getDateKeyFromSlot(locationSlot) === slotDateKey && occupiedSlotIds.has(locationSlot.id)
                            ));
                        })
                        .map(slot => getDateKeyFromSlot(slot))
                );

                const localDates = slotsAtLocation.map(s => {
                    const { day, month, year } = getDateFromSlotStartTime(s.start_time);
                    return {
                        day: day,
                        month: month,
                        year: year,
                        id: '' + day + month + year,
                        peopleCount: peopleCountByDateKey[getDateKeyFromSlot(s)] || 0
                    };
                });
                // console.log('Local Dates', localDates)
                let keys = {};
                let localDatesFiltered = [];
                localDates.forEach(l => {
                    const dateKey = getDateKeyFromDateParts(l);
                    if (keys[l.id] || !visibleDateKeys.has(dateKey)) {
                        return
                    } else {
                        keys[l.id] = true
                        localDatesFiltered.push(l);
                    }
                })

                localDatesFiltered.sort((left, right) => {
                    const leftDate = new Date(left.year, left.month, left.day);
                    const rightDate = new Date(right.year, right.month, right.day);

                    return rightDate.getTime() - leftDate.getTime();
                });

                setDates(localDatesFiltered);
            })
            .catch(
                e => {
                    //console.log("Error fetching slots or users:" + e)
                    alert("There was an error connecting to our server to load the pickup slots or users. Please logout, login and try again. Error: " + e)
                    logout()
                }
            )
    }

    // function onlyUnique(value, index, self) {
    //     return self.indexOf(value) === index;
    // }


    function loadData() {
        if (formData.location && formData.date) {
            //console.log('formData:',formData);
            let loc = formData.location;
            //alert('LOCATION: '+loc);
            let day = formData.date.split('/')[0];
            let month = formData.date.split('/')[1];
            let year = formData.date.split('/')[2];
            //console.log('date in loadData() ->'+day+"/"+month+"/"+year)

            let info = {
                location_id: loc,
                day: day,
                month: month,
                year: year,
            }
            //console.log(info)
            fetch("/getSchedule", {
                method: "POST",
                body: JSON.stringify(info),
                headers: { "Content-Type": "application/json" }
            })
                .then(res => res.json())
                .then(response => {
                    let rows = response;
                    //console.log('Reservations: ', rows);
                    let localData = { ...formData }
                    localData.data = rows;
                    setLoaded(true);
                    setFormData(localData);
                });

        } else {
            alert('Choose a place and a date.')
        }
    }


    return (
        <main>
            <div className="content wrapper">
                <h3>Schedule</h3>
                <form className="wrapper">
                    {user.type === "superAdmin" ?
                        <>
                            <label htmlFor="locationBox">Location <small></small> :</label><br />
                            <select onChange={handleChangeInput} id="location" name="location" type="select" required value={formData.location ? formData.location : 'choose'}>
                                <option value="choose">-- Choose an option --</option>
                            </select>
                        </>
                        :
                        <>
                            <label htmlFor="locationBox">Location <small>(you can only see your location)</small></label><br />
                            <select disabled id="location" name="location" type="select" required value={user.location ? user.location : 'choose'}>
                                <option value="choose">-- Choose an option --</option>
                            </select></>
                    }

                    <label htmlFor="locationBox">Date* :</label><br />
                    <select onChange={handleChangeInput} id="date" name="date" type="select" required >
                        <option>-- Choose an option --</option>
                    </select>
                    <button type="button" onClick={loadData} className="otherButton">Load Data</button>


                    {loaded && formData.data ?
                        <Schedule location={formData.location} location_name={formData.name} date={formData.date} data={formData.data} user={user} loadData={loadData} sendEmail={sendEmail} />
                        : <h2>Select a Location and date</h2>}

                </form>
            </div>
        </main>
    )
}
export default Print;